import React from 'react';
import { components, OptionProps } from 'react-select';
import styled from 'styled-components';

import { DepartureOption } from '@lt/api/dist/types/departure';

import { LocationIcon } from '../../styles';

type CustomOptionProps = OptionProps<
  DepartureOption & { isClosed?: boolean; destinationLabel?: string },
  false
>;

export const Option = (props: CustomOptionProps) => {
  const {
    data: { label, isAutomaticallyDetected, distance, description, isClosed, destinationLabel },
  } = props;

  return (
    <components.Option {...props}>
      <Title $isDetected={isAutomaticallyDetected} $isClosed={isClosed}>
        <span>{label}</span>
        {isAutomaticallyDetected && <LocationIcon />}
      </Title>
      {(description || distance || isClosed) && (
        <Subtitle $isClosed={isClosed}>
          {isClosed ? (
            <span> Нет вылетов {destinationLabel} </span>
          ) : (
            <>
              <span>{description}</span>
              {!isAutomaticallyDetected && <Distance>{distance} км</Distance>}
            </>
          )}
        </Subtitle>
      )}
    </components.Option>
  );
};

const Title = styled.div<{ $isDetected?: boolean; $isClosed?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  font-weight: ${({ $isDetected }) => ($isDetected ? 'bold' : 'normal')};
  color: ${({ $isClosed }) => ($isClosed ? '#919499' : '#17181a')};
`;

const Subtitle = styled.div<{ $isClosed?: boolean }>`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 16px;
  color: ${({ $isClosed }) => ($isClosed ? '#FD6434' : '#919499')};
  gap: 8px;
`;

const Distance = styled.span`
  white-space: nowrap;
`;
